function HorizontalStats(props) {
    const stats = props.stats || [
        { value: props.item1, desc: props.item1desc },
        { value: props.item2, desc: props.item2desc },
        { value: props.item3, desc: props.item3desc },
    ].filter((s) => s.value !== undefined);

    return (
        <div className="w-full flex flex-col lg:flex-row justify-between text-golden font-bold text-5xl m-auto">
            {stats.map((stat, i) => (
                <div
                    key={i}
                    className={`flex flex-col items-center flex-grow-0 w-full ${i > 0 ? "mt-8 lg:mt-0" : ""}`}
                    style={{ flexBasis: `${100 / stats.length}%` }}
                >
                    <div>{stat.value}</div>
                    <div className="text-3xl font-normal">{stat.desc}</div>
                </div>
            ))}
        </div>
    );
}

export default HorizontalStats;
